import Box from '@mui/material/Box';
import { IconEco2 } from '../../../../../../assets/icons/icon-eco-2';
import { IconSadFaceDashboard } from '../../../../../../assets/icons/icon-sad-face-dashboard';

type EcoIconProps = {
  iconColor: string;
};

export const LeafLeft: React.FC<EcoIconProps> = ({ iconColor }) => (
  <Box
    sx={{
      position: 'absolute',
      transform: 'rotate(180deg)',
      top: -15,
      left: 0,
      '[stroke]': {
        stroke: iconColor,
      },
    }}
  >
    <IconEco2 big />
  </Box>
);

export const LeafRight: React.FC<EcoIconProps> = ({ iconColor }) => (
  <Box
    sx={{
      position: 'absolute',
      bottom: -15,
      right: 0,
      '[stroke]': {
        stroke: iconColor,
      },
    }}
  >
    <IconEco2 big />
  </Box>
);

export const FaceLeft: React.FC<EcoIconProps> = ({ iconColor }) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      '[fill]': {
        fill: iconColor,
      },
    }}
  >
    <IconSadFaceDashboard side="left" />
  </Box>
);

export const FaceRight: React.FC<EcoIconProps> = ({ iconColor }) => (
  <Box
    sx={{
      position: 'absolute',
      bottom: -5,
      right: 0,
      '[fill]': {
        fill: iconColor,
      },
    }}
  >
    <IconSadFaceDashboard side="right" />
  </Box>
);
